var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('app-tabela',{attrs:{"itens":_vm.contrato.dotacoesOrcamentarias,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }